import './polyfills';
import '../Scss/Base.scss';
// TODO should be removed later
import '../Scss/Fonts.scss';
import './Lib';
import '../Scss/mscr-gallery.scss';
import '@bopf/components/Page';
import '@bopf/components/General';
import '@bopf/components/Gallery';
import '@bopf/components/PromotionalContent';
import '@bopf/components/NameRange';
import '@bopf/components/Navigation';
import '@bopf/components/Header';
import '@bopf/components/Map';
import '@bopf/components/Video';
import '@bopf/components/QuickAccess';
import { init as initForms } from '@bopf/components/Form';
import '@bopf/components/Footer';
import '@bopf/components/Search';
import '@bopf/components/Backend';
import '@bopf/components/Theater';

document.addEventListener('DOMContentLoaded', () => {
    initForms();
});
